export const FULLSTORY_EVENTS = {
  FUNNELS: {
    SIGNUP: 'signup-funnel',
  },
  DOWNLOAD: {
    PAGE_VIEWED: 'download_page_viewed',
    STARTED: 'download_started',
  },
  HOME: {
    PAGE_VIEWED: 'home_page_viewed',
    STARTED: 'home_started',
  },
} as const;
